import NameBlock from "./NameBlock";
import {getTextByCurrentLanguage} from "../../../../../utils/functions";
import ChecklistTabs from "./ChecklistTabs";
import DownloadDocument from "./document/DownloadDocument";
import ChecklistHeader from "./ChecklistHeader";
import ChecklistAccordion from "./accordion/ChecklistAccordion";
import AlertChecklistEmpty from "./AlertChecklistEmpty";
import React, {FC, useState} from "react";
import styled from "styled-components/macro";
import {Property} from "../../../../../models/Property";
import {Skeleton as MuiSkeleton} from "@material-ui/lab";
import {ClpData} from "../../../../../models/Clp";
import Swal from "sweetalert2";
import {partialUpdateA11y} from "../../../../../services/a11yesService";
import {useTranslation} from "react-i18next";
import {useSelector} from "../../../../../redux/store";
import {IUser} from "../../../../../models/User";
import {getUserProfile} from "../../../../../selectors";

const Skeleton = styled(MuiSkeleton)`
  background-color: #232F3E;
`

type PropsType = {
    property: Property
    data: ClpData[],
    onSetData: (values: ClpData[]) => void
    isLoading: boolean
}

const ChecklistPointsTab: FC<PropsType> = ({
    property,
    data,
    onSetData,
    isLoading
}) => {
    const { t } = useTranslation()
    const user = useSelector((state) => state.authReducer.user);
    const userProfile = useSelector<IUser | undefined>(getUserProfile);
    const [selectedTab, setSelectedTab] = useState(0);

    const updateChecklist = async (id: string, index: number) => {
        Swal.fire({
            title: t("CLP_AreYouSure"),
            text: t("CLP_UpdateMessage"),
            confirmButtonText: t("CLP_YesUpdate"),
            cancelButtonText: t("CLP_Cancel"),
            showCancelButton: true,
            reverseButtons: true,
            width: '400px'
        }).then((result) => {
            if (result.isConfirmed) {
                const selectedClp = data[selectedTab].clps[index]
                partialUpdateA11y(id, { is_absent: selectedClp.is_done }, user!.token);
                const newClpData = data.map((data, indexData) => {
                    if (indexData === selectedTab) {
                        data.clps = data.clps.map((clp, indexClp) => {
                            if (indexClp === index) {
                                clp.is_done = !clp.is_done
                                if (userProfile) {
                                    clp.updated_by = `${userProfile.first_name} ${userProfile.last_name}`
                                }
                                clp.updated_at = new Date().toString()
                            }
                            return clp
                        })
                        return data
                    }
                    return data
                })
                onSetData(newClpData)
            }
        })
    }

    return (
        <>
            {property ? (
                <NameBlock name={getTextByCurrentLanguage(property.name)}/>
            ): (
                <Skeleton variant='rect' height={128} style={{borderRadius: 6, margin: '20px 0'}}/>
            )}

            { data.length > 0 ? (
                <>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <ChecklistTabs
                            clpData={data}
                            value={selectedTab}
                            setValue={setSelectedTab}
                        />
                        <DownloadDocument
                            clpData={data}
                            property={property}
                        />
                    </div>
                    <ChecklistHeader/>
                    <ChecklistAccordion
                        clps={data[selectedTab].clps}
                        selectedTab={selectedTab}
                        onUpdateChecklist={updateChecklist}
                    />
                </>
            ) : null }

            { !isLoading && data.length === 0 ? (
                <AlertChecklistEmpty propertyID={property?.id} propertyName={getTextByCurrentLanguage(property?.name)}/>
            ) : null }
            {isLoading ? (
                <Skeleton variant='rect' height={600} style={{borderRadius: 6}}/>
            ) : null}
        </>
    )
}

export default ChecklistPointsTab